import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';

import './styles.css';

const propTypes = {
  startAnim: PropTypes.bool.isRequired,
  isPaused: PropTypes.func.isRequired,
  resumeAnim: PropTypes.bool.isRequired,
};

export default class BottleAnimation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pauseAnim: false,
    };
  }

  componentDidMount() {
    this.anim = lottie.loadAnimation({
      container: this.animationContainer,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/bottle.json',
    });

    this.anim.addEventListener('enterFrame', this.pauseAnim);
    this.anim.addEventListener('complete', this.stopAttack);
  }

  componentDidUpdate(prevProps) {
    const { startAnim, resumeAnim } = this.props;
    const { pauseAnim } = this.state;

    if (prevProps.startAnim !== startAnim && !pauseAnim) {
      this.playAnim();
    }

    if (resumeAnim && pauseAnim) {
      this.resumeAnim();
    }
  }

  pauseAnim = animation => {
    const { isPaused } = this.props;

    if (Math.round(animation.currentTime) === 23) {
      this.anim.pause();
      this.setState({ pauseAnim: true }, () => isPaused());
    }
  };

  resumeAnim = () => {
    this.setState({ pauseAnim: false }, this.playAnim());
  }

  playAnim = () => {
    this.anim.play();
  };

  render() {
    return (
      <div className={`${isMobile ? 'mobile' : ''} bottle-animation-container`}>
        <div ref={ref => { this.animationContainer = ref; }} />
      </div>
    );
  }
}

BottleAnimation.propTypes = propTypes;
